module.exports = __webpack_public_path__ + "static/media/success-notification-sound.ef382c4b.mp3";